import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import { useEffect } from 'react';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import imgHANSA_FLEX_SERBIA_BRANCH_BEOGRAD_LESTLANE from '../../../assets/Journey/HANSA_FLEX_SERBIA_BRANCH_BEOGRAD_LESTLANE.webp'
import imglastane1 from '../../../assets/Branch/lestane/lestane1.jpg';
import imglastane2 from '../../../assets/Branch/lestane/lestane2.jpg';
import imglastane3 from '../../../assets/Branch/lestane/lestane3.jpg';

const Branch6 = () => {
    const data1 = {
        image: imgHANSA_FLEX_SERBIA_Cylindercentre_04,
        title: "Hydraulic cylinder",
        description: "Hydraulic cylinders perform extremely heavy work. As the most important drive elements in hydraulics, they convert the pressure energy of the hydraulic fluid into mechanical energy. Cylinders can transmit very high forces while producing uniform and precise movements. HANSA-FLEX sells a wide range of single- and to double-acting standard cylinders and manufactures customised hydraulic cylinders up to 8,000 mm in height.",
        buttonName: "Learn More",
        buttonLink: "/cylinder",
    }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [
        {
            image: imglastane1,
        },
        {
            image: imglastane2,
        },
        {
            image: imglastane3,
        },
    ]
    return (
        <div>

            <CenterStage imageSrc={imgHANSA_FLEX_SERBIA_BRANCH_BEOGRAD_LESTLANE} title={"Welcome to HANSA-FLEX Leštane"} paragraph={"Opened in 2022 in order to cover the South Eastern part of the Belgrade, branch Leštane managed to attract not only the old customers from that area but also many new ones from the region. Just like the larger branches, this smaller one can fully service any customer whatever the problem is."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />

            <ThreeDImageCarousel items={carouselData} />


            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>

        </div>
    )
}

export default Branch6